import Banner from "../components/homepage/Banner";
import Services from "../components/homepage/Services";
import Products from "../components/homepage/Products";

import { UseLangContext } from "../contexts/Lang";
import Client from "../components/homepage/Client";
import AboutUs from "../components/homepage/AboutUs";
import WhyUs from "../components/homepage/WhyUs";

type Props = {};

const HomePage = (props: Props) => {
  const {
    t: { homepage, categoryProducts, services },
  } = UseLangContext();

  return (
    <div>
      {/* Banner Hero */}
      <section className="h-full" id="home">
        <Banner lang={homepage} />
      </section>
      {/* Client */}
      <section
        className="h-full px-6 lg:px-20 py-[40px] lg:py-[60px]"
        id="client"
      >
        <Client lang={homepage} />
      </section>
      {/* About Us */}
      <section
        className="h-full px-6 lg:px-20 py-[40px] lg:py-[60px]"
        id="aboutus"
      >
        <AboutUs lang={homepage} />
      </section>
      {/* SERVICE */}
      <section
        className="h-full py-[40px] lg:py-[60px] bg-[#F9F9F9]"
        id="service"
      >
        <Services services={services} lang={homepage} />
      </section>
      {/* PRODUCT */}
      <section className="h-full py-[40px] lg:py-[60px]" id="prod">
        <Products products={categoryProducts} lang={homepage} />
      </section>
      {/* Why Us */}
      <section className="h-full py-[40px] lg:py-[60px]" id="whyus">
        <WhyUs lang={homepage} />
      </section>
    </div>
  );
};

export default HomePage;
